/* src/app/private/components/email-config/create-email-config/create-email-config.component.scss */
/*# sourceMappingURL=create-email-config.component.css.map */
